/**
 * Formats a number for display in the given language.
 *
 * Separate from `useFormattedNumber` because a grid `valueFormatter` is a plain callback and
 * cannot call a hook — and a cell that formats differently from the export it feeds is a bug
 * waiting to be reported. Both go through this.
 *
 * @param value - The number to format.
 * @param language - The language tag to format for.
 * @param precision - Decimal places, shown whether or not they are significant.
 * @param missing - What to return for a value that is not a finite number.
 * @returns The formatted number.
 */
export function formatNumber(
  value: number | null | undefined,
  language: string,
  precision = 0,
  missing = "---",
): string {
  if (typeof value !== "number" || !Number.isFinite(value)) {
    return missing;
  }

  return value.toLocaleString(language, {
    maximumFractionDigits: precision,
    minimumFractionDigits: precision,
  });
}
